import FindAssetDetailModel from "./FindAssetDetailModel.js";
import FindAssetDetailModelEditor from "./FindAssetDetailModelEditor.js";
import FindAssetDetailRenderer from "./FindAssetDetailRenderer.js";
import FindAssetAction from "./FindAssetAction.js";
import FindAssetCancelAction from "./FindAssetCancelAction.js";
import FindTagDetailModel from "./FindTagDetailModel.js";
import FindTagDetailRenderer from "./FindTagDetailRenderer.js";
import FindTagAction from "./FindTagAction.js";
import FindTagCancelAction from "./FindTagCancelAction.js";
export default {
  install(molten) {
    // Find Asset
    molten.addPlugin('Model', {
      type: FindAssetDetailModel.TYPE,
      model: FindAssetDetailModel
    });
    molten.addPlugin('ModelEditor', {
      type: FindAssetDetailModel.TYPE,
      editor: FindAssetDetailModelEditor
    });
    molten.addPlugin('Detail', {
      name: 'Find Asset',
      objectType: 'assetTags',
      create: () => FindAssetDetailModel.create('assetTags'),
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: FindAssetDetailModel.TYPE,
      renderer: FindAssetDetailRenderer
    });
    molten.addPlugin('Action', FindAssetAction);
    molten.addPlugin('Action', FindAssetCancelAction);

    // Find Tag
    molten.addPlugin('Model', {
      type: FindTagDetailModel.TYPE,
      model: FindTagDetailModel
    });
    molten.addPlugin('ModelEditor', {
      type: FindTagDetailModel.TYPE,
      editor: FindAssetDetailModelEditor
    });
    molten.addPlugin('Detail', {
      name: 'Find Tag',
      objectType: 'tag',
      create: () => FindTagDetailModel.create('tag'),
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: FindTagDetailModel.TYPE,
      renderer: FindTagDetailRenderer
    });
    molten.addPlugin('Action', FindTagAction);
    molten.addPlugin('Action', FindTagCancelAction);
  }
};